import dayjs from 'dayjs';

import { DATE_FORMAT_TEMPLATE } from 'api/constants';
import { promoCodeRedemptionType } from 'types';

type PromoCodeRedemptionsListProps = {
  redemptions: Array<promoCodeRedemptionType>;
};

export function PromoCodeRedemptionsList({
  redemptions,
}: PromoCodeRedemptionsListProps) {
  if (!redemptions.length) {
    return <p className={'p-2'}>User has not redeemed any promo code</p>;
  }

  return (
    <div data-test-id={'e2e-promo-code-redemptions'}>
      <div className={'flex bg-gray-100 mb-1 font-semibold text-sm p-2'}>
        <span className={'w-1/4'}>Promo code</span>
        <span className={'w-1/4'}>Campaign</span>
        <span className={'w-1/4'}>Redeemed at</span>
        <span className={'w-1/4'}>Renewals</span>
      </div>
      {redemptions.map((redemption) => (
        <div
          key={redemption.reservationId}
          className={'flex border-b-gray-500 border p-2 text-sm'}
          data-test-id={'e2e-promo-code-redemption-row'}
        >
          <span className={'w-1/4 font-medium'}>
            {redemption.promoCodeInfo.code}
          </span>
          <span className={'w-1/4'}>
            {redemption.promoCodeInfo.campaignName || '—'}
          </span>
          <span className={'w-1/4'}>
            {dayjs(redemption.redeemedAt).format(DATE_FORMAT_TEMPLATE)}
          </span>
          <span className={'w-1/4'}>
            {redemption.promoCodeInfo.maximumNumberOfRenewals === null
              ? redemption.numberOfRenewals
              : `${redemption.numberOfRenewals} / ${redemption.promoCodeInfo.maximumNumberOfRenewals}`}
          </span>
        </div>
      ))}
    </div>
  );
}
